import { withRetry, createError } from '../../utils/requests/withRetry.js';

let endpoint = '';

try {
  endpoint = import.meta.env.VITE_CONTEXT_ENGINE_ARTICLE_ENDPOINT;
} catch {}

function toBinaryStr(str) {
  const encoder = new TextEncoder();
  const charCodes = encoder.encode(str);
  return String.fromCharCode(...charCodes);
}

export default async function shipContext(slotId, overrideUrl, text) {
  const makeRequest = async attempt => {
    const articleBase64 = window.btoa(toBinaryStr(text));
    const payload = {
      slotId,
      articleBase64,
      referrer: overrideUrl || window.location.href
    };
    const headers = { 'Content-Type': 'application/json' };

    if (attempt > 0) headers['x-retry'] = attempt.toString();

    const req = await fetch(endpoint, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload)
    });

    if (!req.ok) {
      throw createError(
        `HTTP ${req.status} ${req.statusText}`,
        req.status,
        req.statusText,
        await req.text(),
        req.status < 500 ? 'ArticleContextCollection' : undefined
      );
    }

    return req;
  };

  try {
    return await withRetry(makeRequest);
  } catch (error) {
    if (!error.errorOrigin) error.errorOrigin = 'ArticleContextCollection';
    throw error;
  }
}
